import { CUSTOM_TAB_TYPE } from "../../../../types/common.type";
import { CUSTOM_TAB_PAGE_TYPE } from "../../../../types/pages.type";

const COMBINE_TAB_EXCLUDED_DASHBOARDS = new Set([
	CUSTOM_TAB_PAGE_TYPE.ADMISSION,
	CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING,
]);

function isExcludedDashboardOrDataPoint(value) {
	if (value == null || value === "") return false;
	return COMBINE_TAB_EXCLUDED_DASHBOARDS.has(String(value));
}

/**
 * True if combine tab should be hidden in transfer-status picker (Admission or Overall incoming).
 * Checks: root `dashboardType` (set by API processFiltersAsync from main card), each filter group's
 * `dashboard`, and nested `filters[].card.dataPoint` (combine-tab card shape from AddCombineTabDialog).
 */
export function combineTabUsesExcludedDashboard(tab) {
	if (isExcludedDashboardOrDataPoint(tab?.dashboardType)) {
		return true;
	}

	const groups = tab?.filters;
	if (!Array.isArray(groups)) {
		return false;
	}

	for (const group of groups) {
		if (isExcludedDashboardOrDataPoint(group?.dashboard)) {
			return true;
		}
		const rows = group?.filters;
		if (!Array.isArray(rows)) {
			continue;
		}
		for (const row of rows) {
			if (isExcludedDashboardOrDataPoint(row?.card?.dataPoint)) {
				return true;
			}
		}
	}

	return false;
}

/**
 * Custom + combine tabs shown under Hospital / Community / Deceased in transfer-status picker.
 * Combine tabs that reference Admission or Overall incoming are excluded.
 */
export function getTransferStatusEligibleTabsForPage(pageTabs) {
	if (!Array.isArray(pageTabs)) {
		return [];
	}
	return pageTabs.filter((tab) => {
		if (tab?.type === CUSTOM_TAB_TYPE.combineTab) {
			return !combineTabUsesExcludedDashboard(tab);
		}
		return tab?.type === CUSTOM_TAB_TYPE.customTab;
	});
}
